import React, { useState } from 'react';
import { Calculator } from 'lucide-react';

const inputCls = 'sera-input w-full bg-[#18181B] border border-[#27272A] rounded-xl px-4 py-3 text-white text-sm outline-none transition-colors';

function SliderField({ label, value, onChange, max, suffix = '%' }) {
  return (
    <div>
      <div className="flex items-center justify-between mb-2">
        <label className="text-sm text-zinc-400">{label}</label>
        <span className="text-sm font-semibold text-[#00E5FF]">{value}{suffix}</span>
      </div>
      <input
        type="range"
        min={0}
        max={max}
        value={value}
        onChange={(e) => onChange(Number(e.target.value))}
        className="w-full accent-[#00E5FF]"
      />
    </div>
  );
}

export function ValueCalculator() {
  const [searches, setSearches] = useState(5000);
  const [ticket, setTicket] = useState(45);
  const [noResultsPct, setNoResultsPct] = useState(12);
  const [recoveryPct, setRecoveryPct] = useState(20);

  const recoveredOrders = Math.round(searches * (noResultsPct / 100) * (recoveryPct / 100));
  const recoveredRevenue = recoveredOrders * ticket;

  return (
    <section data-testid="pricing-value-calculator" className="py-16 md:py-24 px-6 max-w-4xl mx-auto">
      <div className="text-center mb-10">
        <div className="inline-flex items-center gap-2 text-[#00E5FF] text-xs uppercase tracking-widest font-semibold mb-3">
          <Calculator size={14} /> Calculadora de valor
        </div>
        <h2 className="text-3xl md:text-4xl font-black tracking-tighter text-white mb-4">
          ¿Cuánto podrías estar perdiendo hoy?
        </h2>
        <p className="text-zinc-400 max-w-xl mx-auto leading-relaxed">
          Ajusta los valores con tus propios datos. Es una estimación ilustrativa que tú mismo
          controlas — no un dato garantizado ni una cifra oficial de Sera.
        </p>
      </div>

      <div className="rounded-3xl border border-white/10 bg-[#0F0F11] p-8 grid md:grid-cols-2 gap-8">
        <div className="space-y-6">
          <div>
            <label className="text-sm text-zinc-400 mb-2 block">Búsquedas mensuales en tu buscador</label>
            <input
              type="number"
              data-testid="calc-input-searches"
              className={inputCls}
              value={searches}
              onChange={(e) => setSearches(Math.max(0, Number(e.target.value)))}
            />
          </div>
          <div>
            <label className="text-sm text-zinc-400 mb-2 block">Ticket medio de tu tienda (€)</label>
            <input
              type="number"
              data-testid="calc-input-ticket"
              className={inputCls}
              value={ticket}
              onChange={(e) => setTicket(Math.max(0, Number(e.target.value)))}
            />
          </div>
          <SliderField label="% de búsquedas que hoy no encuentran nada" value={noResultsPct} onChange={setNoResultsPct} max={40} />
          <SliderField label="% de esas búsquedas que crees recuperables" value={recoveryPct} onChange={setRecoveryPct} max={50} />
        </div>

        <div className="flex flex-col items-center justify-center text-center rounded-2xl bg-[#00E5FF]/5 border border-[#00E5FF]/20 p-6">
          <p className="text-xs uppercase tracking-widest text-zinc-500 mb-2">Venta potencial recuperada / mes</p>
          <p data-testid="calc-result-revenue" className="text-4xl md:text-5xl font-black text-white mb-2">
            {recoveredRevenue.toLocaleString('es-ES')}€
          </p>
          <p data-testid="calc-result-orders" className="text-sm text-zinc-400">
            ≈ {recoveredOrders.toLocaleString('es-ES')} pedidos adicionales al mes
          </p>
        </div>
      </div>
    </section>
  );
}
